export enum CardBulkOrderStatus {
  New = 'new',
  Executed = 'executed',
  Failed = 'failed',
  Expired = 'expired'
}

export interface CardBulkOrder {
  uid: string;
  status: CardBulkOrderStatus;
  typeName: string;
  createdAt: string;
  updatedAt: string;
  retiredAt?: string;
  revNr: string;
  curHash: string;
  prvHash: string;
  data: {
    contractUid: string;
    requestingAgentUid: string;
    orderDate: string;
    executionDate: string;
    cardProgramUid: string;
    orderFileName: string;
    processedFileName: string;
    language: string;
    resourceOwnerUid: string;
    executorUid: string;
    cardOrdersCount: number;
  };
  histPrevUid: string;
  ownerEntityUid: string;
  ownerUid: string;
}
